import React, { useState } from 'react';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import { Container } from '~/styles/pagesStyle';
import CardLista from './CardLista';

function GrupoLista() {
  const [loading, setLoading] = useState(false);

  return (
    <Container>
      <Menu />
      <Footer />
      <CardLista setLoading={setLoading} loading={loading} />
    </Container>
  );
}

export default GrupoLista;
